'use strict';
angular.module('TurneroApp').component('coModuloConfirmacion', {
    bindings: {
        ciudadano: '<',
        agenda: '<',
        turnoDetalle: '<',
        modalidad: '<',
        fechaDia: '<'
    },
    controller: [
        '$window',
        'turnosService',
        '$state',
        '$rootScope',
        '$scope',
        'TurneroAppConstant',
        'utilsService',
        '$localStorage',
        '$mdDialog',
        'agendaService',
        '$q',
        function ($window, turnosService, $state, $rootScope, $scope, TurneroAppConstant, utilsService, $localStorage, $mdDialog, agendaService, $q) {
            var ctrl = this;
            ctrl.mostrarErrorPatente = false;
            ctrl.mensajeErrorPatente = '';
            ctrl.Turno = null
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.EmailTasas = null;
            ctrl.ConfirmandoTurno = false;
            ctrl.limpiarMemoria = function () {
                ctrl.Turno = ctrl.turnoDetalle;
            }

            function getIdentificadorSolicitante() {
                var cuil = ctrl.ciudadano && ctrl.ciudadano.Datos_Cidi
                    ? ctrl.ciudadano.Datos_Cidi.N_Ciudadano_Cidi
                    : null;
                var dni = ctrl.ciudadano && ctrl.ciudadano.Datos_RegistroCivil
                    ? ctrl.ciudadano.Datos_RegistroCivil.Nro_Documento
                    : null;

                return {
                    cuil: cuil,
                    dni: dni
                };
            }

            ctrl.getIdentificadorSolicitanteLabel = function () {
                var identificador = getIdentificadorSolicitante();

                return utilsService.tieneCuilParaMostrar(identificador.cuil) ? 'CUIL' : 'DNI';
            };

            ctrl.getIdentificadorSolicitanteValor = function () {
                var identificador = getIdentificadorSolicitante();

                return utilsService.tieneCuilParaMostrar(identificador.cuil) ? identificador.cuil : (identificador.dni || '');
            };

            ctrl.getIdentificadorSolicitanteComprobante = function () {
                var identificador = getIdentificadorSolicitante();

                return utilsService.tieneCuilParaMostrar(identificador.cuil) ? utilsService.CUIL_Formateado(identificador.cuil) : (identificador.dni ? 'DNI ' + identificador.dni : '');
            };

            function validarFormatoPatente(valor) {
                if (!valor || !valor.trim()) return false;

                var n = utilsService.normalizarPatente(valor);

                var vieja = /^[A-Z]{3}\s*\d{3}$/;          // ABC 123
                var mercosur = /^[A-Z]{2}\s*\d{3}\s*[A-Z]{2}$/; // AB 123 CD

                return vieja.test(n) || mercosur.test(n);
        }

            ctrl.normalizarPatenteInput = function () {
                if (ctrl.turnoDetalle && ctrl.turnoDetalle.Patente_Dominio) {
                    ctrl.turnoDetalle.Patente_Dominio =
                        utilsService.normalizarPatente(ctrl.turnoDetalle.Patente_Dominio);
                }   
        };

            ctrl.$onChanges = function () {
                if (ctrl.fechaDia) {
                    ctrl.limpiarMemoria();
                    ctrl.getConfirmacionesDocumentos();
                }
            };            

            ctrl.limpiarDatosAPIExterna = function () {
				ctrl.Agenda.APILink = null;
				ctrl.Agenda.Respuesta = null;
			}

            //LOADING BLOCK (SOLO COPIAR)
            ctrl.loading = true;
            ctrl.ajaxArray = [];
            ctrl.d1 = $q.defer();
            ctrl.d2 = $q.defer();
            ctrl.d3 = $q.defer();

            ctrl.ajaxArray.push(ctrl.d1.promise)
            ctrl.ajaxArray.push(ctrl.d2.promise)
            ctrl.ajaxArray.push(ctrl.d3.promise)

            $q.all(ctrl.ajaxArray).then(function () {
                ctrl.loading = false;
            });
            //---------------------------

            ctrl.getConfirmacionesDocumentos = function () {
                if (ctrl.turnoDetalle && ctrl.agenda && ctrl.ciudadano) {
                    utilsService.swalNotification('Un momento...', 'Obteniendo datos...', 'info');

                    turnosService.Get_PreConfirmacion_Asistencia({
                        'filtro.Id_Agenda': ctrl.agenda.Agenda.id,
                        'filtro.Id_Tramite_Relevado': ctrl.agenda.Tramite.id,
                        'filtro.N_Ciudadano': ctrl.ciudadano.Datos_Cidi.N_Ciudadano_Cidi,
                    }).$promise.then(function (resultado) {
                        ctrl.d1.resolve();
                        swal.close();
                        ctrl.Id_Tramite_Aplicacion = resultado.Data.Id_Tramite_Aplicacion;
                        ctrl.Notificaciones = resultado.Data.Notificaciones;
                        ctrl.agenda.CentroSeleccionado.N_Centro_Atencion = resultado.Data.N_Centro_Atencion;
                        ctrl.agenda.CentroSeleccionado.Domicilio = resultado.Data.Domicilio;
                        ctrl.documentacionTramite = resultado.Data.Tramite;
                        ctrl.turnoDetalle.Notifica = {
                            Mail: 'S',
                            Telefono: 'S'
                        }
                        ctrl.mostrarCampos = {
                            Datos_Adicionales: resultado.Data.Permite_Datos_Adicionales == 'S',
                            Observaciones: resultado.Data.Permite_Observaciones == 'S',
                            Solicita_Patente_Dominio: resultado.Data.Solicita_Patente_Dominio == 'S'
                        }
                    }).catch(function (error) {
                        ctrl.d1.resolve();
                        utilsService.errores(error);
                    });
                }
            }
                   

            ctrl.onClickAceptar = function () {
                ctrl.mostrarErrorPatente = false;
                ctrl.mensajeErrorPatente = '';

                if (ctrl.mostrarCampos.Solicita_Patente_Dominio) {

                    var patenteNorm = utilsService.normalizarPatente(
                    ctrl.turnoDetalle.Patente_Dominio
                );

                if (!patenteNorm) {
                    ctrl.mostrarErrorPatente = true;
                    ctrl.mensajeErrorPatente = 'Campo obligatorio';
                    return;
                }

                if (!validarFormatoPatente(patenteNorm)) {
                     ctrl.mostrarErrorPatente = true;
                     ctrl.mensajeErrorPatente =
                        'Formato de patente inválido. Ej: ABC 123 o AB 123 CD';
                    return;
                }

                 // Guardar normalizada
                ctrl.turnoDetalle.Patente_Dominio = patenteNorm;
            }
                ctrl.ConfirmandoTurno = true;
                ctrl.Turno.Patente_Dominio = ctrl.Turno.Patente_Dominio != null ? ctrl.Turno.Patente_Dominio.trim() : ''
                if (ctrl.Id_Tramite_Aplicacion && (ctrl.appExterna && ctrl.appExterna.Columnas.length > 0)){
                    
                    ctrl.ConfirmacionAppExterna();
                }
                else {
                    ctrl.GuardarTurno();
                }
            }

            ctrl.GuardarTurno = function () {
                ctrl.input_Tasas_Tramite = null;
                utilsService.swalNotification('Un momento...', 'Reservando Turno...', 'info');
                //if (ctrl.GenerarTasas()) {
                    if ((!ctrl.ciudadano.Datos_Cidi.NombreYApellido && !ctrl.EmailTasas) && ctrl.input_Tasas_Tramite) {
                        return;
                    }
                    var Turno = {
                        Id_Sexo: ctrl.ciudadano.Datos_RegistroCivil == null ? null : ctrl.ciudadano.Datos_RegistroCivil.Id_Sexo,
                        Id_Numero: ctrl.ciudadano.Datos_RegistroCivil == null ? null : ctrl.ciudadano.Datos_RegistroCivil.Id_Numero,
                        Nro_Documento: ctrl.ciudadano.Datos_RegistroCivil == null ? null : ctrl.ciudadano.Datos_RegistroCivil.Nro_Documento,
                        Pai_Cod_Pais:  ctrl.ciudadano.Datos_RegistroCivil == null ? null : ctrl.ciudadano.Datos_RegistroCivil.Pai_Cod_Pais,
                        N_Usuario_Cidi: ctrl.ciudadano.Datos_Cidi.N_Ciudadano_Cidi,
                        //03/06/2019 Se va a enviar en formato simil ISO pero SIN Timezone
                        //Fec_Turno_string: (ctrl.turnoDetalle.Turno.dia.getDate().toString() + '/' + (ctrl.turnoDetalle.Turno.dia.getMonth() + 1).toString() + '/' + ctrl.turnoDetalle.Turno.dia.getFullYear().toString() + ' ' + ctrl.turnoDetalle.Turno.hora),
                        Fec_Turno: ctrl.turnoDetalle.Turno.dia.getFullYear() + '-' + (ctrl.turnoDetalle.Turno.dia.getMonth() + 1) + '-' + ctrl.turnoDetalle.Turno.dia.getDate() + 'T' + ctrl.turnoDetalle.Turno.hora,
                        Id_Tramite_Relevado: ctrl.agenda.Tramite.id,
                        Id_Modalidad: ctrl.modalidad,
                        Datos_Adicionales: ctrl.turnoDetalle.datos_Adicionales ? ctrl.turnoDetalle.datos_Adicionales : '',
                        Observaciones: ctrl.turnoDetalle.observaciones ? ctrl.turnoDetalle.observaciones : '',
                        Patente_Dominio: ctrl.turnoDetalle.Patente_Dominio ? ctrl.turnoDetalle.Patente_Dominio.trim() : '',
                        Notificar_Sms: ctrl.turnoDetalle.Notifica.Telefono,
                        Notificar_Email: ctrl.turnoDetalle.Notifica.Mail,
                        Sujeto_Ley_9131: '',
                        Id_Agenda: parseInt(ctrl.agenda.Agenda.id),
                        //Id_Prioridad: '', //24/04/2019 Si se envía como un empty string donde corresponde un int el backend lo rechaza en .NET Core
                        I_AppExterna: ctrl.input_App_Externa ? ctrl.input_App_Externa : null,
                        //24/04/2019 Estaba mal hecho, ya que usar la variable interna "_i" lo único que hace es devolver el valor string de entrada, el cual NO corresponde al formato ISO_8601
                        //Fec_Solicitado: moment(ctrl.turnoDetalle.Turno.dia.getDate() + '/' + (ctrl.turnoDetalle.Turno.dia.getMonth() + 1) + '/' + ctrl.turnoDetalle.Turno.dia.getFullYear() + 'T' + ctrl.turnoDetalle.Turno.hora, moment.ISO_8601)._i,
                        //03/06/2019 SE COMPROBÓ QUE NO LO USA EL BACKEND
                        //Fec_Solicitado: ctrl.turnoDetalle.Turno.dia.getFullYear() + '/' + (ctrl.turnoDetalle.Turno.dia.getMonth() + 1) + '/' + ctrl.turnoDetalle.Turno.dia.getDate() + 'T' + ctrl.turnoDetalle.Turno.hora,
                        Tasas: ctrl.input_Tasas_Tramite ? ctrl.input_Tasas_Tramite : null,
                        Email: ctrl.ciudadano.Datos_Cidi.EMail ? null : ctrl.EmailTasas
                    };

                    var TurnoPost_Service = ctrl.modalidad == ctrl.Modalidades.Presencial ? turnosService.Post_Turno_Presencial : turnosService.Post_Turno_Telefonico;
                    TurnoPost_Service(Turno).$promise.then(function (resultado) {
                        swal.close();
                        var turnoDetalle = {
                            N_Tramite: ctrl.agenda.Tramite.text,
                            N_Centro_Atencion: ctrl.agenda.CentroSeleccionado.text,
                            Fec_Turno: ctrl.turnoDetalle.Turno.dia.getDate() + '/' + (ctrl.turnoDetalle.Turno.dia.getMonth() + 1) + '/' + ctrl.turnoDetalle.Turno.dia.getFullYear(),
                            Hora_Desde: ctrl.turnoDetalle.Turno.hora,
                            Id_Turno: resultado.Data.Id_Turno,
                            Mensaje_Respuesta: resultado.Data.Mensaje
                        }

                        ctrl.reimprimirTurno(turnoDetalle);
                    }).catch(function (error) {
                        swal.close();
                        utilsService.errores(error);
                    }).finally(() => ctrl.ConfirmandoTurno = false);
                //} else {
                //    swal.close()
                //    sweetAlert("Faltan completar datos", 'Se deben completar todos los datos de tasas retributivas.', "warning");
                //}
            }

            ctrl.reimprimirTurno = function (turno) {
                ctrl.esTelefonico = ctrl.modalidad == ctrl.Modalidades.Atencion_Telefonica;
                ctrl.asistencia = ctrl.modalidad == ctrl.Modalidades.Presencial;
                ctrl.turnoSeleccionado = turno;
                ctrl.turnoSeleccionado.Domicilio = ctrl.agenda.CentroSeleccionado.Domicilio
                ctrl.turnoSeleccionado.usuario = {
                    nombre: ctrl.ciudadano.Datos_Cidi.NombreYApellido,
                    CUIT: ctrl.getIdentificadorSolicitanteComprobante()
                };
                $mdDialog.show({
                    template: require('../turnos/turnosOnline/modalComprobante.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: false, // Only for -xs, -sm breakpoints.,
                    controllerAs: '$ctrl',
                    controller: function () {
                        return ctrl;
                    }
                });
            };

            ctrl.cerrarModal = function () {
                ctrl.esTelefonico = false;
                ctrl.asistencia = false;
                $mdDialog.destroy();
                ctrl.cancelar()
            };

            ctrl.ImprimirComprobante = function (Id_Turno) {
                ctrl.turnoSeleccionado = null;
                $window.open('#!/reimprimir?Id_Turno=' + Id_Turno + '&Desde_Ciudadano=false', '_blank');
                ctrl.cerrarModal();
            };

            ctrl.cancelar = function () {
                //ctrl.limpiarTasas();
                $rootScope.$broadcast('cancelarConfirmacion', false);
            }

            ctrl.volverACalendario = function () {
                $rootScope.$broadcast('volverACalendario', true);
            }
        }],
    template: require('./Confirmacion.html')
});



// WEBPACK FOOTER //
// ./app/components/asistencia/ConfirmacionComponent.js